import React from "react";

export default function Collection() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32"
    >
      <path
        fill="#76A9FA"
        d="M11.513 4.8a1.6 1.6 0 000 3.2h9.6a1.6 1.6 0 000-3.2h-9.6zm-4.8 6.4a1.6 1.6 0 011.6-1.6h16a1.6 1.6 0 010 3.2h-16a1.6 1.6 0 01-1.6-1.6zm-3.2 6.4a3.2 3.2 0 013.2-3.2h19.2a3.2 3.2 0 013.2 3.2V24a3.2 3.2 0 01-3.2 3.2h-19.2a3.2 3.2 0 01-3.2-3.2v-6.4z"
      ></path>
    </svg>
  );
}
